import React from "react";
import "./Pagination.css";

const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <ul className="pagination">
      <li className="page-item">
        <a
          onClick={() => currentPage > 1 && paginate(currentPage - 1)}
          style={{
            cursor: "pointer",
            margin: "0 5px",
            padding: "5px 10px",
            backgroundColor: currentPage > 1 ? "#007bff" : "#cccccc", // Disabled look if on first page
            color: "white",
            borderRadius: "5px",
            textDecoration: "none",
          }}
        >
          &#9664; {/* Left arrow */}
        </a>
      </li>
      {pageNumbers.map((number) => (
        <li key={number} className="page-item">
          <a
            onClick={() => paginate(number)}
            style={{
              cursor: "pointer",
              margin: "0 5px",
              padding: "5px 10px",
              backgroundColor:
                currentPage === number ? "#007bff" : "transparent", // Highlight current page
              color: currentPage === number ? "white" : "#007bff", // White text for current page, blue for others
              borderRadius: "5px",
              textDecoration: "none",
              border: "1px solid #007bff", // Border to make transparent buttons visible
            }}
            onMouseOver={(e) =>
              (e.target.style.backgroundColor =
                currentPage === number ? "#0056b3" : "#e7e7e7")
            } // Darker shade on hover or light grey for non-current
            onMouseOut={(e) =>
              (e.target.style.backgroundColor =
                currentPage === number ? "#007bff" : "transparent")
            } // Revert to original
            aria-current={currentPage === number ? "page" : undefined}
          >
            {number}
          </a>
        </li>
      ))}
      <li className="page-item">
        <a
          onClick={() =>
            currentPage < pageNumbers.length && paginate(currentPage + 1)
          }
          style={{
            cursor: "pointer",
            margin: "0 5px",
            padding: "5px 10px",
            backgroundColor:
              currentPage < pageNumbers.length ? "#007bff" : "#cccccc", // Disabled look if on last page
            color: "white",
            borderRadius: "5px",
            textDecoration: "none",
          }}
        >
          &#9654; {/* Right arrow */}
        </a>
      </li>
    </ul>
  );
};

export default Pagination;
